import { useTranslate } from 'react-polyglot';

import { EmojiIcon } from '@genially/icons';

import { ConfigToggle } from '../ConfigToggle/ConfigToggle';

export const ReactionsToggle = ({
  isEnabled,
  onChange,
}: {
  isEnabled: boolean;
  onChange: () => void;
}) => {
  const t = useTranslate();

  return (
    <ConfigToggle
      Icon={EmojiIcon}
      text={t('__new.play.shared.configuration.modal.reactionsSwitch')}
      checked={isEnabled}
      onChange={onChange}
    />
  );
};
